import { BadgeCheck } from "lucide-react";
import { useMall } from "@/context/MallContext";
import { tint } from "@/lib/mall";

/** Stamps a page/section with the shop you're standing in. */
export function VerifiedShop({ className = "", note, testid = "verified-shop-badge" }) {
    const { store, theme } = useMall();
    const name = store?.name || "13th Ave";
    return (
        <div className={`inline-flex flex-wrap items-center gap-2 rounded-full border px-3.5 py-1.5 ${className}`}
            style={{ borderColor: tint(theme.primary, 0.4), background: tint(theme.primary, 0.08) }}
            data-testid={testid}>
            <BadgeCheck size={14} className="shrink-0" style={{ color: theme.ink || theme.primary }} />
            <span className="font-mono text-[11px] font-bold uppercase tracking-[0.18em]" style={{ color: theme.ink || theme.primary }}>
                {name} · Verified Shop
            </span>
            {note && <span className="font-mono text-[11px] uppercase tracking-[0.14em] text-zinc-400">{note}</span>}
        </div>
    );
}
